import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Email from './email'
import Access from './access'
import Subscription from './subscription'
import Labels from './labels'

const defaultManageDataRoute = '/site-structure'
const defaultRoute = `/manage${defaultManageDataRoute}/opportunities`

const Routes = () => {
  return (
    <Switch>
      <Route path={`${defaultRoute}/email`} render={() => <Email />} />
      <Route
        path={`${defaultRoute}/subscriptions`}
        render={() => <Subscription />}
      />
      <Route path={`${defaultRoute}/access`} render={() => <Access />} />
      <Route path={`${defaultRoute}/labels`} render={() => <Labels />} />
      <Redirect from={defaultRoute} to={`${defaultRoute}/email`} />
    </Switch>
  )
}

export default Routes
